import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledTitleWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  &&& svg {
    transform: scale(0.75);
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &&& svg {
      transform: scale(1);
    }
  }
`;

export const StyledTitle = styled.div`
  text-transform: uppercase;
  ${pickThemeFontStyles('12', '12', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '16', 'NORMAL')};
  }
`;

export const StyledChartWrapper = styled.div`
  width: 100%;
  height: 30rem;
  display: flex;
  flex-direction: column-reverse;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    height: 50rem;
    flex-direction: row;
  }
`;
